export const cardInfos = {
  full_name: "Yelena O'Hear",
  joined: "Joined April 2021",
  location: "Vatican City",
  contact: "(123) 456-7890",
  email: "john.doe@gmail.com",
  birthday: "02-10-1990",
};
